import { PaginationRequest, PaginationResult } from '@shared/pagination';

import { DrugUtilization } from '@/features/drug-utilization';
import { artiaProtectedApi } from '@/lib/api-client';
import { buildQueryString } from '@/utils/filtering-functions';

export type DrugUtilizationSearchRequest = {
  year?: number;
  state?: string;
  ndc?: string;
  product?: string;
} & PaginationRequest;

export const searchDrugUtilizations = async (
  request: DrugUtilizationSearchRequest,
): Promise<PaginationResult<DrugUtilization>> => {
  return await artiaProtectedApi.get(`medicaid/drug-utilizations${buildQueryString(request)}`);
};
